import type { SVGProps } from 'react';
const SvgVolumeMute = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#volume_mute_svg__a)">
      <path fill="currentColor" d="M7 9v6h4l5 5V4l-5 5H7Z" />
    </g>
    <defs>
      <clipPath id="volume_mute_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgVolumeMute;
